import React, { useContext } from 'react';
import classNames from 'classnames';
import { PageHeaderBandContext } from './band_context';

interface Props {
  currentPage?: number;
  itemDescription?: string;
  loading?: boolean;
  pageSize?: number;
  totalCount?: number;
}

export default function PageHeaderCount({ currentPage, itemDescription, loading, pageSize, totalCount }: Props) {
  const band = useContext(PageHeaderBandContext);

  if (!currentPage || !pageSize || !totalCount || loading) {
    return null;
  }

  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalCount);
  return (
    <span className={classNames('text-muted d-none d-md-block', { 'fs-small': band })}>
      Displaying <strong>{start}-{end}</strong> of{' '}
      <strong>{totalCount}</strong>
      {itemDescription ? ` ${itemDescription}` : ''}
    </span>
  );
}
